import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, Observable } from 'rxjs';
import { catchError, concatMap, map, mergeMap, switchMap } from 'rxjs/operators';
import {
  GET_ALL_RECEPIENTS,
  GET_INBOX_LABELS, GET_MAIL_BY_ID, GetAllRecepientsAction, GetAllRecepientsFailedAction, GetAllRecepientsSuccessAction,
  GetInboxLabelsAction,
  GetInboxLabelsFailedAction,
  GetInboxLabelsSuccessAction, GetMailByIdAction, GetMailByIdFailedAction, GetMailByIdSuccessAction, SAVE_REPLY_MAIL,
  SaveReplyMailAction, SaveReplyMailFailedAction, SaveReplyMailSuccessAction, GET_MAIL_BY_ID_SUCCESS, OTHERS_MAIL_ALERT,
  MyMailAlertAction
} from '../actions/inbox.actions';
import { InboxApiService } from '../../services/inbox-api.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { CommandService } from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {DoNothingAction, NotifyOthersAction} from '@shared/store/actions/particle.actions';
import {MarkMailAsReadCommand} from '../../commands/inbox.command';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {Store} from '@ngrx/store';
import {getUserInfo} from '@shared/store/selectors/security.selector';

@Injectable()
export class InboxEffects {
  private userInfo$: any;
  private userInfo: any;
  constructor ( private fuseSplashScreenService: FuseSplashScreenService,
                protected commandService: CommandService,
                private actions$: Actions ,
                private snackBarService: SnackBarService,
                private inboxApiService: InboxApiService,
                private securityStore: Store<SecurityState>
    ) {
    this.userInfo$ = this.securityStore.select(getUserInfo);
    this.userInfo$.subscribe(state => {
      this.userInfo = state;
    });
  }

  mailAlertReceived$ = createEffect(() => this.actions$.pipe( ofType(OTHERS_MAIL_ALERT) )
    .pipe(
      mergeMap((action: NotifyOthersAction) => {
        let payload = null;
        if (this.userInfo && action.payload && action.payload.Payload && this.userInfo.email === action.payload.Payload.Email) {
          payload = action.payload;
        }
        return [new MyMailAlertAction(payload)];
      })
    ));

  getAllRecepientsAction$ = createEffect(() => this.actions$.pipe( ofType(GET_ALL_RECEPIENTS) )
    .pipe(
      mergeMap((action: GetAllRecepientsAction) => {
          return this.inboxApiService.getAllRecepients().pipe(
          concatMap((payload: any) => {
            return [new GetAllRecepientsSuccessAction(payload)];
          }),
          catchError(error => {
            this.snackBarService.showError('Get recepients failed');
            return of (new GetAllRecepientsFailedAction(error));
          }));
      })
    ));

  saveReplyAction$ = createEffect(() => this.actions$.pipe( ofType(SAVE_REPLY_MAIL) )
    .pipe(
      mergeMap((action: SaveReplyMailAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(data => {
              this.fuseSplashScreenService.hide();
              return new GetMailByIdAction(action.currentMailId);
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
            return  of(new SaveReplyMailFailedAction(error));
            })
          );
      })
    ));

  getInboxLabelsAction$ = createEffect(() => this.actions$.pipe( ofType(GET_INBOX_LABELS) )
    .pipe(
      mergeMap((action: GetInboxLabelsAction) => {
        return this.inboxApiService.getMailLabels().pipe(
          concatMap((payload: any) => {
            return [new GetInboxLabelsSuccessAction(payload.data.mailLabels)];
          }),
          catchError(error => {
            this.snackBarService.showError('Labels Loading Failed!');
            this.fuseSplashScreenService.hide();
            return of (new GetInboxLabelsFailedAction(error));
          }));
      })
    ));

  getMailByIdAction$ = createEffect(() => this.actions$.pipe( ofType(GET_MAIL_BY_ID) )
    .pipe(
      mergeMap((action: GetMailByIdAction) => {
        this.fuseSplashScreenService.show();
        return this.inboxApiService.getMailById(action.id).pipe(
          concatMap((payload: any) => {
            this.fuseSplashScreenService.hide();
            return [new GetMailByIdSuccessAction(payload, new MarkMailAsReadCommand(payload.mailThread.id, true))];
          }),
          catchError(error => {
            this.snackBarService.showError('Mail Loading Failed!');
            this.fuseSplashScreenService.hide();
            return of (new GetMailByIdFailedAction(error));
          }));
      })
    ));

  getMailByIdSuccessAction$ = createEffect(() => this.actions$.pipe( ofType(GET_MAIL_BY_ID_SUCCESS) )
    .pipe(
      mergeMap((action: GetMailByIdSuccessAction) => {
        return this.commandService.executeCommand(action.command).pipe(
          concatMap((payload: any) => {
            return [new DoNothingAction()];
          }),
          catchError(error => {
            this.snackBarService.showError('Mark Mail As Read Failed!');
            this.fuseSplashScreenService.hide();
            return [new DoNothingAction()];
          }));
      })
    ));
}


